import {
  ObservableState,
  Routine,
  persistentReducedStream,
} from 'rxbeach';
import { crudActions } from './crudActions';
import { crudApiService } from './crudApiService';
import {
  ApiServiceShape,
  crudApiServiceReducers,
  defaultApiServiceShape,
} from './crudApiServiceReducers';
import { CrudState, crudReducers, defaultState } from './crudReducers';
import { crudRoutines } from './crudRoutines';
import { CrudActions, CrudApiService, EntityTypeItem } from './types';

type CrudStreamReturn<Request, EntityType extends EntityTypeItem, E> = [
  CrudActions<Request, EntityType>,
  Routine<unknown>,
  ObservableState<CrudState<EntityType>>,
  ObservableState<ApiServiceShape>,
  CrudApiService<Request, EntityType>
];

const crudStream = <Request, EntityType extends EntityTypeItem, Error = any>(
  namespace: string,
  url: string
): CrudStreamReturn<Request, EntityType, Error> => {
  const actions = crudActions<Request, EntityType>(namespace);
  const apiService = crudApiService<Request, EntityType>(url);
  const reducers = crudReducers<Request, EntityType>(actions);
  const routines = crudRoutines<Request, EntityType>(actions, apiService);

  const model$ = persistentReducedStream<CrudState<EntityType>>(
    namespace,
    defaultState,
    reducers
  );

  const loadingStateReducer = crudApiServiceReducers<Request, EntityType>(
    actions
  );

  const apiServiceState$ = persistentReducedStream<ApiServiceShape>(
    `${namespace}api`,
    defaultApiServiceShape,
    loadingStateReducer
  );

  return [actions, routines, model$, apiServiceState$, apiService];
};

export default crudStream;
